module.exports = {
    ACTIVE: 'active',
    DELETED: 'deleted',
    ARCHIVED: 'archived',
    MERGED: 'merged'
};